module.exports = __webpack_public_path__ + "media/newstyle/images/icon-exit-aila-editor-42342fbf72cbb500bdbebd362a45135d.svg";